import UrlApi from './urlApi'
import localStorage from 'store';
import unorm from 'unorm' // polyfill for String.prototype.normalize


export const getTravels = () => {
	return fetch(`${UrlApi}/seaports`)
		.then(res => res.json())
}

export const getLimits = () => {
	return fetch(`${UrlApi}/config/fastbooking-limits`)
		.then(res => res.json())
}

export const getAvailableDates = (values, settings) => {
	const { nAdults, nTeens, nKids, nBabies, nPets } = values
	const { nCars, nMotorcycles, nVans, nTowing, nBikes } = values

	const origin = settings.travels[values.origin]
	const destiny = origin.destinations[values.destiny]
	return fetch(`${UrlApi}/travels/available-dates?
		origin=${origin._id}&
		destination=${destiny._id}&
		passengers={"adult":"${nAdults}","kid":"${nKids}","baby":"${nBabies}","teen":"${nTeens}","pet":"${nPets}"}&
		vehicles={"car":"${nCars}","van":"${nVans}","motorcycle":"${nMotorcycles}","bike":"${nBikes}","towing":"${nTowing}"}`)
		.then(res => res.json())
}

export const getAvailable = (data, settings) => {
	const { travel, nAdults, nTeens, nKids, nBabies, nPets } = data.values
	const { nCars, nMotorcycles, nVans, nTowing, nBikes } = data.values
	const { departuredate, returndate } = data.values

	const origin = settings.travels[data.values.origin]
	const destiny = origin.destinations[data.values.destiny]
	const returnDate = (travel === 0) ? `&returnDate=${getDate(returndate)}` : ''
	const send = `origin=${origin._id}&
		destination=${destiny._id}&
		passengers={"adult":"${nAdults}","kid":"${nKids}","baby":"${nBabies}","teen":"${nTeens}","pet":"${nPets}"}&
		vehicles={"car":"${nCars}","van":"${nVans}","motorcycle":"${nMotorcycles}","bike":"${nBikes}","towing":"${nTowing}"}&
		departureDate=${getDate(departuredate)}
		${returnDate}`

	return fetch(`${UrlApi}/travels/available?${send}`)
		.then(res => res.json())
}

export const getMonthTable = (settings, seaportName, isOrigin, month, year) => {
	// we don't need redux for this as this is loaded every time a
	// 'seaports table' search is done!

	// look for seaportName's ID
	let seaportId = null;
	const normalize = (str) => str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
	settings.travels.forEach((seaport) => {
		if (normalize(seaport.name) === normalize(seaportName)) {
			seaportId = seaport._id;
		}
	});

	// if seaportId was not found it means that it does
	// not exist or it is disabled
	if (seaportId === null) {
		return false;
	}

	const query = `seaport=${seaportId}&
		year=${year}&
		month=${month}&
		isOrigin=${isOrigin}`

	return fetch(`${UrlApi}/travels/month-table?${query}`)
		.then(res => res.json())
}

const getPassanger = (go, data, settings, name, index) => {
	const { locations } = settings.languages.es
	const key = `${name + index}`
	const passenger = data[key]
	let obj = '{'
	obj += `"id":"${index}",`
	obj += `"type":"${name}",`

	if (name === 'baby') {
		obj += `"seat":null,`
	} else {
		if (passenger !== undefined) {
			let val = ((go === 0) ? locations[passenger.locationGone].id : locations[passenger.locationReturn].id)
			obj += `"seat":"${val}",`
			if (passenger.birthDate !== undefined) {
				try { // evade date error
					let date = new Date(passenger.birthDate)
					obj += `"birth":"${date.toISOString()}",`
				} catch (e) { }
			}
		} else {
			obj += `"seat":"basic",`
		}
	}

	obj = obj.substr(0, obj.length - 1)
	obj += '},'
	return obj
}

const ParseInt = (root, value) => (
	(root !== undefined) ? (root[value] !== undefined) ? parseInt(root[value], 0) : 0 : 0
)

const getVehicles = (go, data, settings, name, index) => {
	const { displacement, towings } = settings.languages.es
	const key = `${name + index}`
	const vehicle = data[key]
	const disp = ParseInt(vehicle, 'displacement')
	const tow = ParseInt(vehicle, 'towing')

	let obj = '{'
	obj += `"id":"${index}",`
	obj += `"type":"${name}",`
	obj += ((name === 'car') ? `"subtype":null,` : '')
	obj += ((name === 'van') ? `"subtype":null,` : '')
	obj += ((name === 'motorcycle') ? `"subtype":"${displacement[disp].id}",` : '')
	obj += ((name === 'towing') ? `"subtype":"${towings[tow].id}",` : '')

	obj = obj.substr(0, obj.length - 1)
	obj += '},'
	return obj
}

const getRightPromo = (offer) => {
	let promo = 'default';
	if (offer !== undefined) {
		promo = offer;
	}

	return promo;
}

export const getCalc = (travel, go, data, settings) => {
	const { passangers, vehicles } = settings.definedData
	const { bFamily, bCouple, nPets, nBikes, offer } = data.values

	let passengersList = ""
	for (let i = 0; i < passangers.length; i++) {
		let { name, count } = passangers[i]
		for (let k = 1; k <= data.values[count]; k++) {
			passengersList += getPassanger(go, data, settings, name, k)
		}
	}
	for (let i = 1; i <= nPets; i++) {
		passengersList += `{"id":"${i}", "type":"pet", "seat":null},`
	}

	passengersList = passengersList.substr(0, passengersList.length - 1)
	passengersList = "[" + passengersList + "]"

	let vehiclesList = ""
	for (let i = 0; i < vehicles.length; i++) {
		let { name, count } = vehicles[i]
		for (let k = 1; k <= data.values[count]; k++) {
			vehiclesList += getVehicles(go, data, settings, name, k)
		}
	}
	for (let i = 1; i <= nBikes; i++) {
		vehiclesList += `{"id":"${i}", "type":"bike", "subtype":null},`
	}

	vehiclesList = vehiclesList.substr(0, vehiclesList.length - 1)
	vehiclesList = "[" + vehiclesList + "]"

	// select the right string for promo
	const promo = getRightPromo(offer);

	const send = `travel=${travel}&
		passengersList=${passengersList}&
		vehiclesList=${vehiclesList}&
		go=${go === 0 ? true : false}&
		promo=${promo}&
		checks={"largeFamily":"${bFamily}","couple":"${bCouple}"}`

	return fetch(`${UrlApi}/rates/calc?${send}`)
		.then(res => res.json())
}

const getDate = (date) => {
	const mDate = new Date(date)
	const y = mDate.getFullYear()
	const m = mDate.getMonth()
	const d = mDate.getDate()
	return (`${y}/${m + 1}/${d}`)
}

const getPassangerFull = (data, settings, name, index) => {
	const { locations } = settings.languages.es
	const key = `${name + index}`
	const passenger = data[key]

	const day = (parseInt(passenger.birthDate.split('/')[0], 10) + 1).toString()
	const month = passenger.birthDate.split('/')[1]
	const year = passenger.birthDate.split('/')[2]
	const finalDate = month + '-' + day + '-' + year

	const date = new Date(finalDate)

	let obj = {}
	obj["id"] = index
	obj["type"] = name


	if (name === 'baby') {
		obj["name"] = passenger.name
		obj["surname"] = passenger.surname
		obj["secondSurname"] = passenger.secondSurname
		obj["nationality"] = passenger.nationality
		obj["numberDocument"] = passenger.numberDocument
		obj["gender"] = passenger.gender
		obj["birth"] = date.toISOString()
		obj["seat"] = null
		obj["seatReturn"] = null
	} else {
		obj["name"] = passenger.name
		obj["surname"] = passenger.surname
		obj["secondSurname"] = passenger.secondSurname
		obj["nationality"] = passenger.nationality
		obj["numberDocument"] = passenger.numberDocument
		obj["gender"] = passenger.gender
		obj["birth"] = date.toISOString()
		obj["seat"] = locations[passenger.locationGone].id
		obj["seatReturn"] = locations[passenger.locationReturn].id
	}

	return obj
}

const getVehiclesFull = (data, settings, name, index) => {
	const { displacement, towings } = settings.languages.es
	const key = `${name + index}`
	const vehicle = data[key]
	const disp = ParseInt(vehicle, 'displacement')
	const tow = ParseInt(vehicle, 'towing')

	let obj = {}
	obj["id"] = index
	obj["type"] = name
	obj["brand"] = vehicle.brand
	obj["model"] = vehicle.model
	obj["licensePlate"] = vehicle.licensePlate
	obj["exported"] = (vehicle.exported !== undefined) ? vehicle.exported : false

	if (name === 'motorcycle') {
		obj["subtype"] = displacement[disp].id
	} else if (name === 'towing') {
		obj["subtype"] = towings[tow].id
	}

	return obj
}

const createJson = (settings, data, lang) => {
	const { passangers, vehicles } = settings.definedData
	const { travel, bFamily, bCouple, nPets, offer } = data.values

	let passengersList = []
	for (let i = 0; i < passangers.length; i++) {
		let { name, count } = passangers[i]
		for (let k = 1; k <= data.values[count]; k++) {
			passengersList.push(getPassangerFull(data, settings, name, k))
		}
	}
	for (let i = 1; i <= nPets; i++) {
		passengersList.push({ "id": `${i}`, "type": "pet", "seat": null, "name": null, "surname": null, "secondSurname": null, "nationality": null, "numberDocument": null, "birth": null, "gender": null })
	}

	let vehiclesList = []
	for (let i = 0; i < vehicles.length; i++) {
		let { name, count } = vehicles[i]
		for (let k = 1; k <= data.values[count]; k++) {
			vehiclesList.push(getVehiclesFull(data, settings, name, k))
		}
	}

	// select the right string for promo
	const promo = getRightPromo(offer);

	let obj = {}
	obj["travel"] = settings.available.departures[data.values.departuretravel]._id
	if (travel === 0) obj["travelReturn"] = settings.available.returns[data.values.returntravel]._id
	obj["contact"] = {
		"name": `${data.contact.name}`,
		"surname": `${data.contact.surname}`,
		"secondSurname": `${data.contact.secondSurname}`,
		"numberDocument": `${data.contact.numberDocument}`,
		"prefix": `${data.contact.prefix}`,
		"phone": `${data.contact.phone}`,
		"email": `${data.contact.email}`,
		"postalcode": `${data.contact.postalcode}`,
	}
	obj["passengersList"] = passengersList.map(p => {
		const { seatReturn, ...noSeatReturn } = p
		return noSeatReturn
	})
	if (travel === 0) {
		obj["passengersListReturn"] = passengersList.map((p) => {
			// use seatReturn as seat
			p.seat = p.seatReturn
			const { seatReturn, ...noSeatReturn } = p
			return noSeatReturn
		})
	}
	obj["vehiclesList"] = vehiclesList
	obj["promo"] = promo
	obj["checks"] = { "largeFamily": bFamily, "couple": bCouple }
	obj["langCode"] = lang
	return obj
}

export const getPayload = (settings, data, lang) => {
	const details = data;
	details.contact.secondSurname = ' ' + data.contact.secondSurname;
	const obj = createJson(settings, details, lang)

	return fetch(`${UrlApi}/order/payment`,
		{
			method: 'post',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(obj)
		}).then(res => res.json())
}

export const getCheck = (reference) => {
	return fetch(`${UrlApi}/order/check?reference=${reference}`)
		.then(res => res.json())
}

export const getFinish = (data) => {
	const send = `token=${localStorage.get('token')}&ref=${data.payment.order.reference}`

	return fetch(`${UrlApi}/order/finish`, {
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		body: send
	}).then(res => res.json())
}

export const sendContactForm = (data) => {
	const params = Object.entries(data).reduce((total, pair) => {
		const [key, value] = pair
		const sep = total.length ? '&' : ''
		return `${total}${sep}${key}=${value}`
	}, '')

	return fetch(`${UrlApi}/contact/send?${params}`, {
		method: 'post',
	}).then(res => res.json());
}

export const removeTemporalDetails = (userKey) => {
	return fetch(`${UrlApi}/temporalDetails/delete/${userKey}`)
		.then(res => res.json())
}

export const createTemporalDetails = (details) => {
	const body = JSON.stringify(details);

	return fetch(`${UrlApi}/temporalDetails/create`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body
		})
		.then(res => res.json())
}

export const retrieveTemporalDetails = (userKey) => {
	return fetch(`${UrlApi}/temporalDetails/${userKey}`)
		.then(res => res.json())
}


// WEBPACK FOOTER //
// ./src/shared/lib/ApiServices.js